export const M5_READING_PRACTICE = {
  id: "m5-reading-practice",
  title: "Reading Practice / Práctica de Lectura",
  topic: "Practice your reading comprehension! Five complete texts covering all Module 5 topics: job applications, social planning, entertainment, and future plans. Read carefully paragraph by paragraph and answer questions to demonstrate your understanding. No grammar questions - just show you understand!",
  iconType: "book-open",
  
  sets: [
    // ===================================================================
    // READING 1: Job Application Email (Units 11, 14)
    // ===================================================================
    {
      id: "m5-reading-1",
      title: "Reading 1: A Job Application Follow-Up",
      questions: [
        {
          type: "mc",
          q: "READ PARAGRAPH 1:\n\n'Dear Ms. Johnson,\n\nThank you for interviewing me last Tuesday for the Marketing Manager position at Creative Solutions. I really enjoyed meeting you and learning more about the company. I was very impressed by the office and the friendly staff. Everyone seemed happy to work there, and I think the company culture is excellent.'\n\nWhen was the interview?",
          options: ["Last Tuesday", "Last Friday", "Next Tuesday"],
          a: "Last Tuesday"
        },
        {
          type: "input",
          q: "What position did the person apply for?",
          a: "Marketing Manager",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "mc",
          q: "What did the person think about the company?",
          options: ["The culture is excellent", "It's too small", "The staff seemed unhappy"],
          a: "The culture is excellent"
        },
        {
          type: "mc",
          q: "READ PARAGRAPH 2:\n\n'During the interview, we discussed my previous work experience in social media marketing and my qualifications in digital communications. I have five years of experience managing campaigns for major brands, and I believe my skills match perfectly with what you're looking for. I'm particularly excited about the new project you mentioned - the international campaign for the European market. I think my experience working with international clients would be very valuable for this project.'\n\nHow many years of experience does the person have?",
          options: ["Five years", "Three years", "Ten years"],
          a: "Five years"
        },
        {
          type: "input",
          q: "What type of marketing is their experience in?",
          a: "social media",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["social media marketing", "digital"] }
        },
        {
          type: "mc",
          q: "Which project is the person excited about?",
          options: ["The international campaign for European market", "A local advertising project", "A website redesign"],
          a: "The international campaign for European market"
        },
        {
          type: "mc",
          q: "READ PARAGRAPH 3:\n\n'I'm writing to follow up on our conversation and to express my continued interest in the position. I'm going to be in the area next week if you would like to meet again or if you need any additional information from me. I can provide references from my previous managers, and I'm happy to show you examples of my work. I'm very enthusiastic about the opportunity to join your team, and I think I would be a great fit for Creative Solutions.'\n\nWhy is the person writing this email?",
          options: ["To follow up and express continued interest", "To cancel the application", "To ask about salary"],
          a: "To follow up and express continued interest"
        },
        {
          type: "input",
          q: "When is the person going to be in the area?",
          a: "next week",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "mc",
          q: "What can the person provide?",
          options: ["References and work examples", "Only references", "Only a resume"],
          a: "References and work examples"
        },
        {
          type: "mc",
          q: "READ PARAGRAPH 4:\n\n'I look forward to hearing from you soon about the next steps in the hiring process. Please feel free to contact me at any time by email or phone. I'm available for a second interview whenever is convenient for you. Thank you again for considering my application.\n\nBest regards,\nMichael Chen'\n\nWhat is Michael waiting for?",
          options: ["Information about next steps", "His first paycheck", "A rejection letter"],
          a: "Information about next steps"
        },
        {
          type: "input",
          q: "How can Ms. Johnson contact Michael? (name two ways)",
          a: "email or phone",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["email and phone", "phone or email", "phone and email", "by email or phone"] }
        },
        {
          type: "mc",
          q: "COMPREHENSION: This email shows that Michael is:",
          options: ["Professional, interested, and prepared", "Desperate and pushy", "Uninterested in the job"],
          a: "Professional, interested, and prepared",
          successtip: "✓ Perfect! Professional follow-up emails show continued interest while being polite and prepared."
        }
      ]
    },

    // ===================================================================
    // READING 2: Article - "The Changing Workplace" (Units 11, 13, 14)
    // ===================================================================
    {
      id: "m5-reading-2",
      title: "Reading 2: The Future of Work",
      questions: [
        {
          type: "mc",
          q: "READ PARAGRAPH 1:\n\n'The workplace is changing rapidly, and many experts predict that the traditional nine-to-five office job is going to become less common in the future. More and more companies are allowing their staff to work from home, and some businesses are going completely remote - meaning they don't have a physical office at all. This change is happening because of new technology and because employees are looking for better work-life balance.'\n\nWhat is going to happen to nine-to-five office jobs?",
          options: ["They're going to become less common", "They're going to increase", "Nothing will change"],
          a: "They're going to become less common"
        },
        {
          type: "input",
          q: "What does 'remote' mean in this context?",
          a: "working from home",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["work from home", "no physical office", "not in office"] }
        },
        {
          type: "mc",
          q: "Why is this change happening? (Choose the main reason)",
          options: ["Technology and work-life balance demands", "Companies want to save money", "Offices are too expensive"],
          a: "Technology and work-life balance demands"
        },
        {
          type: "mc",
          q: "READ PARAGRAPH 2:\n\n'However, working from home isn't perfect for everyone. Some people miss the social interaction of an office environment. They feel isolated when they're working alone at home every day. That's why many companies are offering flexible arrangements - employees can choose to work from home some days and come to the office on other days. This is called hybrid working, and it's becoming very popular.'\n\nWhat problem do some remote workers have?",
          options: ["They feel isolated and miss social interaction", "They work too much", "They can't use technology"],
          a: "They feel isolated and miss social interaction"
        },
        {
          type: "input",
          q: "What is 'hybrid working'?",
          a: "work from home some days and office other days",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["mix of home and office", "some home some office", "flexible", "combination"] }
        },
        {
          type: "mc",
          q: "According to the text, hybrid working is:",
          options: ["Becoming very popular", "Not working well", "Only for managers"],
          a: "Becoming very popular"
        },
        {
          type: "mc",
          q: "READ PARAGRAPH 3:\n\n'Another big change is in the types of jobs that are available. Technology is going to replace some traditional jobs, but it's also going to create many new ones. For example, twenty years ago, there were no social media managers or app developers. In the future, there are going to be jobs that we can't even imagine today. Experts say that young people starting their careers now should be flexible and ready to learn new skills throughout their working lives.'\n\nWhat is technology going to do?",
          options: ["Replace some jobs and create new ones", "Only replace jobs", "Only create jobs"],
          a: "Replace some jobs and create new ones"
        },
        {
          type: "input",
          q: "Name ONE job that didn't exist twenty years ago (from the text).",
          a: "social media manager",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["app developer", "social media managers", "app developers"] }
        },
        {
          type: "mc",
          q: "What should young people be ready to do?",
          options: ["Learn new skills throughout their lives", "Choose one job forever", "Avoid technology"],
          a: "Learn new skills throughout their lives"
        },
        {
          type: "mc",
          q: "READ PARAGRAPH 4:\n\n'So what does all this mean for you? If you're looking for a job or planning your career, think about flexibility. Learn skills that you can use in different situations. Don't be afraid of technology - embrace it! And remember that the ability to communicate well and work with others is always going to be valuable, whether you're in an office or working from your kitchen table. The future of work is going to be different, but it's also going to be exciting!'\n\nWhat advice does the article give?",
          options: ["Think about flexibility and learn adaptable skills", "Avoid remote work", "Only learn technical skills"],
          a: "Think about flexibility and learn adaptable skills"
        },
        {
          type: "input",
          q: "What skill is ALWAYS going to be valuable? (according to paragraph 4)",
          a: "communicate well",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["communication", "work with others", "working with others", "communication skills"] }
        },
        {
          type: "mc",
          q: "COMPREHENSION: The article's overall message is:",
          options: ["The workplace is changing, but with flexibility and skills, the future is exciting", "Technology is bad for workers", "Everyone should work from home"],
          a: "The workplace is changing, but with flexibility and skills, the future is exciting",
          successtip: "✓ Excellent! The article presents balanced view: changes bring challenges but also opportunities."
        }
      ]
    },

    // ===================================================================
    // READING 3: Blog Post - Travel Plans (Units 13, 14)
    // ===================================================================
    {
      id: "m5-reading-3",
      title: "Reading 3: Planning My Dream Trip",
      questions: [
        {
          type: "mc",
          q: "READ PARAGRAPH 1:\n\n'I can't believe it's finally happening! After saving money for two years, I'm going to visit Japan next spring! I've been dreaming about this trip since I was a teenager, and now I'm actually going to do it. I'm going to spend three weeks there, and I'm so excited I can barely sleep at night. I think this is going to be the adventure of a lifetime!'\n\nHow long has the person been saving money?",
          options: ["Two years", "One year", "Three years"],
          a: "Two years"
        },
        {
          type: "input",
          q: "When is the person going to Japan?",
          a: "next spring",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "mc",
          q: "How long is the trip going to be?",
          options: ["Three weeks", "Two weeks", "One month"],
          a: "Three weeks"
        },
        {
          type: "mc",
          q: "READ PARAGRAPH 2:\n\n'I'm flying into Tokyo on April 15th, and I'm going to stay there for a week. I'm really interested in the mix of traditional and modern culture. During the day, I'm going to visit ancient temples and beautiful gardens. In the evenings, I'm going to explore the incredible neighborhoods like Shibuya and Harajuku. I've heard the food in Tokyo is amazing, so I'm going to try as many different restaurants as possible. I'm especially excited about trying real sushi and ramen!'\n\nWhat date is the flight?",
          options: ["April 15th", "April 5th", "May 15th"],
          a: "April 15th"
        },
        {
          type: "input",
          q: "Name ONE neighborhood the person is going to visit.",
          a: "Shibuya",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["Harajuku"] }
        },
        {
          type: "mc",
          q: "What is the person excited to try?",
          options: ["Real sushi and ramen", "Only sushi", "Western food"],
          a: "Real sushi and ramen"
        },
        {
          type: "mc",
          q: "READ PARAGRAPH 3:\n\n'After Tokyo, I'm taking the bullet train to Kyoto. I'm going to spend five days there because I really want to see the traditional side of Japan. Kyoto has over 2,000 temples and shrines, and I'm going to visit as many as I can! I'm also going to go to Nara for a day trip - it's famous for the deer that walk freely around the park. I think that's going to be incredible! Then I'm going to travel to Osaka for three days. Osaka is known for its street food and nightlife, so I'm going to eat a lot and explore the city at night.'\n\nHow is the person traveling from Tokyo to Kyoto?",
          options: ["By bullet train", "By plane", "By bus"],
          a: "By bullet train"
        },
        {
          type: "input",
          q: "How many days in Kyoto?",
          a: "five",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["5", "five days", "5 days"] }
        },
        {
          type: "mc",
          q: "What is Nara famous for?",
          options: ["Deer that walk freely in the park", "Temples", "Bullet trains"],
          a: "Deer that walk freely in the park"
        },
        {
          type: "mc",
          q: "READ PARAGRAPH 4:\n\n'For the last week, I'm going to do something different. I'm going to stay in a traditional ryokan - a Japanese inn - in the mountains. It's going to be peaceful and quiet, very different from the busy cities. I'm going to relax, enjoy the hot springs, and eat traditional Japanese meals. I think this is going to be the perfect way to end my trip. I'm a bit nervous about the language barrier, but I'm taking a phrasebook and I've been learning some basic Japanese phrases. I'm sure it's going to be an amazing experience!'\n\nWhat is a ryokan?",
          options: ["A traditional Japanese inn", "A modern hotel", "A mountain temple"],
          a: "A traditional Japanese inn"
        },
        {
          type: "input",
          q: "Where is the ryokan located?",
          a: "in the mountains",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["mountains", "the mountains"] }
        },
        {
          type: "mc",
          q: "COMPREHENSION: How does the person feel about the trip?",
          options: ["Excited and a bit nervous, but confident it will be amazing", "Scared and wanting to cancel", "Not very interested"],
          a: "Excited and a bit nervous, but confident it will be amazing",
          successtip: "✓ Perfect comprehension! The blog shows detailed planning, excitement, realistic concerns, and positive outlook!"
        }
      ]
    },

    // ===================================================================
    // READING 4: Restaurant & Concert Review (Units 12, 13, 14)
    // ===================================================================
    {
      id: "m5-reading-4",
      title: "Reading 4: A Night Out Review",
      questions: [
        {
          type: "mc",
          q: "READ PARAGRAPH 1:\n\n'Last Saturday was one of the best nights I've had in a long time! My friends and I went to the new Italian restaurant downtown called 'Bella Notte,' and then we went to a concert at the Royal Theatre. I'm going to tell you all about it because if you haven't been to either place yet, you're missing out! Both experiences were incredible, and I'm definitely going to go back to both venues.'\n\nWhen did this happen?",
          options: ["Last Saturday", "This Saturday", "Next Saturday"],
          a: "Last Saturday"
        },
        {
          type: "input",
          q: "What is the name of the restaurant?",
          a: "Bella Notte",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "mc",
          q: "What did they do after dinner?",
          options: ["Went to a concert", "Went home", "Went to a movie"],
          a: "Went to a concert"
        },
        {
          type: "mc",
          q: "READ PARAGRAPH 2:\n\n'First, the restaurant. We arrived at 7:00 pm and the atmosphere was perfect - warm lighting, soft music, and the smell of fresh bread and herbs. We didn't have a reservation, but we only waited about 15 minutes for a table. Our waiter, Marco, was friendly and helpful. He recommended the seafood pasta, and it was absolutely delicious! The portions were generous, the ingredients tasted fresh, and the presentation was beautiful. My friends ordered the pizza and risotto, and they loved their meals too. The only downside was the wait for our food - it took about 40 minutes - but it was worth it!'\n\nDid they have a reservation?",
          options: ["No, they didn't", "Yes, they did", "The text doesn't say"],
          a: "No, they didn't"
        },
        {
          type: "input",
          q: "How long did they wait for a table?",
          a: "15 minutes",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["about 15 minutes", "15 mins", "15"] }
        },
        {
          type: "mc",
          q: "What was the only negative thing?",
          options: ["The wait for food was long (40 minutes)", "The food was bad", "The waiter was rude"],
          a: "The wait for food was long (40 minutes)"
        },
        {
          type: "mc",
          q: "READ PARAGRAPH 3:\n\n'After dinner, we walked to the Royal Theatre - it's only five minutes away. We had tickets to see the jazz band 'Blue Monday,' and they were fantastic! The concert started at 9:30 pm and lasted for two hours. The lead singer had an amazing voice, and the saxophone player was incredible. The audience loved every moment - everyone was clapping and cheering. The only problem was that our seats were quite far from the stage, so we couldn't see the musicians very well. Next time, I'm going to buy better seats!'\n\nHow far is the theatre from the restaurant?",
          options: ["Five minutes walking", "Fifteen minutes", "One hour"],
          a: "Five minutes walking"
        },
        {
          type: "input",
          q: "What is the name of the jazz band?",
          a: "Blue Monday",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "mc",
          q: "What was the problem with their seats?",
          options: ["They were too far from the stage", "They were uncomfortable", "They were too expensive"],
          a: "They were too far from the stage"
        },
        {
          type: "mc",
          q: "READ PARAGRAPH 4:\n\n'Overall, it was a perfect evening. The food was excellent, the concert was amazing, and most importantly, I spent time with good friends. The total cost was reasonable too - about $80 per person including dinner, drinks, and the concert ticket. I think that's good value for such a great night out. I'm already planning to go back to Bella Notte next month, and I'm going to check the Royal Theatre's schedule to see what other concerts are coming up. I highly recommend both places!'\n\nHow much did everything cost per person?",
          options: ["About $80", "About $60", "About $100"],
          a: "About $80"
        },
        {
          type: "input",
          q: "Does the reviewer recommend these places?",
          a: "yes",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["highly recommends", "recommends both"] }
        },
        {
          type: "mc",
          q: "COMPREHENSION: What is the main purpose of this review?",
          options: ["To share a positive experience and recommend both places", "To complain about the service", "To describe only the food"],
          a: "To share a positive experience and recommend both places",
          successtip: "✓ Excellent! Balanced review: mostly positive, mentions minor negatives honestly, gives specific details, and clear recommendation!"
        }
      ]
    },

    // ===================================================================
    // READING 5: Conversation Transcript - Planning Weekend (Units 12, 13, 14)
    // ===================================================================
    {
      id: "m5-reading-5",
      title: "Reading 5: Friends Planning a Weekend",
      questions: [
        {
          type: "mc",
          q: "READ PART 1:\n\nAlex: Hey everyone! What are you doing this weekend? I'm thinking about doing something fun.\n\nJordan: I don't have any plans yet. What did you have in mind?\n\nAlex: Well, there's a new art gallery that just opened downtown. I'm thinking of going on Saturday afternoon. Want to come?\n\nJordan: An art gallery? I don't know... That doesn't sound very exciting to me.\n\nSam: Really? I think it sounds interesting! I'm going to be free on Saturday. What time are you thinking?\n\nWho has plans for the weekend already?",
          options: ["Nobody has plans yet", "Alex has plans", "Everyone has plans"],
          a: "Nobody has plans yet"
        },
        {
          type: "input",
          q: "What does Alex want to visit?",
          a: "art gallery",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["a new art gallery", "new art gallery", "gallery"] }
        },
        {
          type: "mc",
          q: "How does Jordan feel about the art gallery idea?",
          options: ["Not very excited about it", "Very enthusiastic", "Definitely wants to go"],
          a: "Not very excited about it"
        },
        {
          type: "mc",
          q: "READ PART 2:\n\nAlex: I'm thinking around 2 pm. The gallery opens at noon, but I don't want to go too early.\n\nJordan: Okay, here's an idea. What if we go to the gallery for an hour or so, and then we do something else? Something more active?\n\nSam: Like what?\n\nJordan: Well, there's a bowling alley near the gallery. We could go bowling after! I haven't been bowling in ages.\n\nSam: That sounds like a great compromise! I'm going to be terrible at bowling though - I haven't played in years!\n\nWhat time does Alex suggest?",
          options: ["Around 2 pm", "Noon", "3 pm"],
          a: "Around 2 pm"
        },
        {
          type: "input",
          q: "What does Jordan suggest they do after the gallery?",
          a: "bowling",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["go bowling"] }
        },
        {
          type: "mc",
          q: "How does Sam feel about bowling?",
          options: ["Likes the idea but thinks they'll be bad at it", "Doesn't want to go", "Is an expert bowler"],
          a: "Likes the idea but thinks they'll be bad at it"
        },
        {
          type: "mc",
          q: "READ PART 3:\n\nAlex: Perfect! So we're meeting at the gallery at 2 pm, and then we're going bowling. What about food? Should we have dinner after?\n\nJordan: Definitely! I'm going to be hungry after all that activity. There's a good burger place near the bowling alley.\n\nSam: Oh, I know that place! But it's always really busy on Saturday nights. We should probably make a reservation.\n\nAlex: Good idea. I'll call them tomorrow. Or actually, I'm going to book online tonight - it's easier.\n\nWhat are they going to do at 2 pm?",
          options: ["Meet at the gallery", "Go bowling", "Have dinner"],
          a: "Meet at the gallery"
        },
        {
          type: "input",
          q: "Why does Sam suggest making a reservation?",
          a: "it's busy on Saturday nights",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["busy", "always busy", "restaurant is busy"] }
        },
        {
          type: "mc",
          q: "How is Alex going to make the reservation?",
          options: ["Online tonight", "By calling tomorrow", "In person"],
          a: "Online tonight"
        },
        {
          type: "mc",
          q: "READ PART 4:\n\nJordan: Great! So Saturday at 2 pm at the art gallery. I'm actually getting excited about this now!\n\nSam: Me too! And we should probably exchange phone numbers in case anyone is running late.\n\nAlex: Good thinking. I'll create a group chat for us. That way we can stay in touch during the day.\n\nJordan: Perfect. This is going to be fun! Thanks for organizing this, Alex.\n\nAlex: No problem! I think it's going to be a great day. See you both on Saturday!\n\nWhy do they want to exchange numbers?",
          options: ["In case someone is running late", "To cancel the plans", "To share photos"],
          a: "In case someone is running late"
        },
        {
          type: "input",
          q: "What is Alex going to create?",
          a: "group chat",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["a group chat"] }
        },
        {
          type: "mc",
          q: "COMPREHENSION: This conversation shows:",
          options: ["Friends negotiating plans, compromising, and organizing details together", "Friends arguing about plans", "One person deciding everything"],
          a: "Friends negotiating plans, compromising, and organizing details together",
          successtip: "✓ Perfect understanding! Real conversations involve: suggesting, negotiating, compromising, planning details, and confirming. Natural social planning! 🎉"
        }
      ]
    }
  ]
};
